import { render, staticRenderFns } from "./Sjjh.vue?vue&type=template&id=177cfbcb&scoped=true"
import script from "./Sjjh.vue?vue&type=script&lang=js"
export * from "./Sjjh.vue?vue&type=script&lang=js"
import style0 from "./Sjjh.vue?vue&type=style&index=0&id=177cfbcb&prod&lang=scss&scoped=true"
import style1 from "./Sjjh.vue?vue&type=style&index=1&id=177cfbcb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177cfbcb",
  null
  
)

export default component.exports